// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { EventEmitter } from '@angular/core';
import { IntellicheckUploadStep } from './intellicheck-upload-step';
import { idn } from 'src/assets/Intellicheck/IDN-Base/IDN-Helper.js';
import { LocalStorageService } from '@services/local-storage.service';
import { IntellicheckPayload } from '@interfaces/document.interfaces';
import { IDScanLog } from './id-scan-logging';

export type ScanTip = { title: string; subtitle: string };

export abstract class IntellicheckUploadComponentBase {
    protected localStorage: LocalStorageService;

    protected abstract moduleElementName: string;
    protected abstract moduleName: string;
    protected abstract imageDataFieldName: string;
    protected failureCount = 0;
    protected maxFailureCount = 2;

    public doneLoading: EventEmitter<any>;
    public partialLoading: EventEmitter<any>;
    public showLoading: EventEmitter<string | undefined | null>;
    public captureComplete: EventEmitter<Partial<IntellicheckPayload>>;
    public returnToJacket: EventEmitter<any>;
    public logScanAtttempt: EventEmitter<IDScanLog>;
    public dealId;
    public documentId;
    public showBackButton: boolean;
    public developmentModeOn: boolean;
    public previewProductionMode: boolean;
    public loadingMessage: string;
    public pageDefaultOverride: any;

    public step: IntellicheckUploadStep = IntellicheckUploadStep.Begin;

    constructor() {
        this.doneLoading = new EventEmitter();
        this.partialLoading = new EventEmitter();
        this.showLoading = new EventEmitter();
        this.captureComplete = new EventEmitter();
        this.returnToJacket = new EventEmitter();
        this.logScanAtttempt = new EventEmitter();
        this.localStorage = new LocalStorageService();
    }

    abstract startCapture();
    abstract continue();
    abstract recapture();

    public return() {
        this.returnToJacket.emit();
    }

    public get showBegin() {
        return this.step === IntellicheckUploadStep.Begin;
    }

    public get showCapture() {
        return this.step === IntellicheckUploadStep.Capture;
    }

    public get showPreview() {
        return this.step === IntellicheckUploadStep.Preview;
    }

    public get showFallback() {
        return this.step === IntellicheckUploadStep.Fallback;
    }
}
